import { bffWebApi } from '~/api';

type TokenResponse = {
  token: string;
};

const websocketTokenApi = bffWebApi.injectEndpoints({
  endpoints: (build) => ({
    getWebSocketToken: build.query<TokenResponse, void>({
      query: () => ({
        url: '/websocket/token',
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetWebSocketTokenQuery } = websocketTokenApi;
export default websocketTokenApi;
